/**
 * When the watched run's current phase began, as epoch milliseconds. Both the progress fill and
 * the countdown measure from it, so they cannot disagree about how far into a phase a run is.
 * @param {object|undefined} run - The watched activeRuns entry
 * @returns {number}
 */
export default function phaseAnchorMs(run) {
  const parsed = run?.phaseUpdatedAt != null ? new Date(run.phaseUpdatedAt).getTime() : NaN
  if (!Number.isNaN(parsed)) {
    return parsed
  }
  return run?.startedAt ?? Date.now()
}
